<template>
    <div>
        <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
          You have only view permission.
        </div>
        <div class="selectdiv mb-4">
            <div class="row" :disabled="!ifTeamleaderAnchorPermission">
                <div class="col-4">
                    <div class="search-container">
                      <tl-search @change="filterDatas($event)" :placeholder="'Search Employee Name'" />
                        <!-- <search-dropdown
                        class="custom-width-search"
                        :placeholder="'Search Employee'"
                        :clearRequired="true"
                        /> -->
                        <!-- THis code comment for active  -->
                        <!-- <a type="button">
                        <img class="search-icon" src="@/assets/magnifying-glass.png" />
                        </a> -->
                    </div>
                </div>
                <div class="col-4">
                    <a class="anchor-underline-none show-filter-block" href="#"
                        ><img class="search-icon-filter" src="@/assets/filter.png" alt="" />
                        <span class="filter-text">Show Filter</span></a
                    >
                </div>
                <div class="col-4">
                    <div class="float-right">
                        <span style="cursor:pointer" @click="bulkuploadSalary">
                            <img class="search-icon-filter" src="@/assets/logout-copy-2.svg" style="width: 30px;height: 34px;" alt /> <span class="filter-text">Bulk File Upload  </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <data-table
        :columns="columnNames"
        :tableData="employeeData"
        :checkbox="false"
        :showinrow="false"
        :with-form="false"
        :disabled="!ifTeamleaderAnchorPermission"
      >
        <template v-slot:rowcontent="slotprops">
          <p
            v-if="slotprops.value.column.key=='code'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='name'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='email_id'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <!-- <p
            v-if="slotprops.value.column.key=='location'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p> -->
            <p
            v-if="slotprops.value.column.key=='effective_from'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <p
            v-if="slotprops.value.column.key=='current_status'"
          >{{slotprops.value.record[slotprops.value.column.key]}}</p>
          <!-- dropdown section starts here -->

         <div class="action-section" v-if="slotprops.value.column.key=='action'">
            <img
              src="@/assets/group-2.png"
              class="pointer-cursor"
              @click="dropdown(slotprops.value.record)"
              alt="actionIcon"
            />
            <ul class="action-menu" v-show="employeeData[slotprops.value.index].showDropDown">
              <li>
                <span class @click="stopSalary(slotprops.value.record)">Stop Salary</span>
              </li>
              <li>
                <span class @click="releaseSalary(slotprops.value.record)">Release Salary</span>
              </li>
            </ul>
          </div>
        </template>
      </data-table>

      <pop-up-window
        v-if="showHoldStopReleasePopup"
        @back="showHoldStopReleasePopup = !showHoldStopReleasePopup"
        header="Hold, Stop or Release Salaries in Bulk">
          <template v-slot:content>
            <hold-stop-release-popup
            @back="showHoldStopReleasePopup = !showHoldStopReleasePopup"
            @hidepopup="popupHide">
            </hold-stop-release-popup>
         </template>

      </pop-up-window>

      <pop-up-window
        v-if="showStopSalaryPopup"
        @back="showStopSalaryPopup = !showStopSalaryPopup"
        header="Stop Salary">
          <template v-slot:content>
            <stop-salary-popup
            @back="showStopSalaryPopup = !showStopSalaryPopup"
            :stopSalaryEmployee="stopSalaryEmployee"
            @hidepopup="popupHide">
            </stop-salary-popup>
         </template>

      </pop-up-window>

      <pop-up-window
        v-if="showreleaseSalaryPopup"
        @back="showreleaseSalaryPopup = !showreleaseSalaryPopup"
        header="Release Salary">
          <template v-slot:content>
            <release-salary-popup
            @back="showreleaseSalaryPopup = !showreleaseSalaryPopup"
            :releaseSalaryEmployee="releaseSalaryEmployee"
            @hidepopup="popupHide">
            </release-salary-popup>
         </template>

      </pop-up-window>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import * as constants from "@/apis/constants.js";
import holdStopReleasePopup from "./holdStopReleasePopup.vue";
import stopSalaryPopup from "./stopSalaryPopup.vue";
import releaseSalaryPopup from "./releaseSalaryPopup.vue";

export default {
    name: "holdSalary",
    components: {
        holdStopReleasePopup,
        stopSalaryPopup,
        releaseSalaryPopup
    }
    ,props: {
    },
    data() {
    return {
      showHoldStopReleasePopup: false,
      showStopSalaryPopup: false,
      showreleaseSalaryPopup: false,
      page: 1,
      totalEmployees: 0,
      criteria: null,
      subCriteria: [],
      uploadMethod: "manualUpload",
      masterSalaryData: [],
      monthList: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      criteriaList: [],
      subCriteriaList: [],
      statusList: [],
      filterData: {
        paygroupId: null,
        criteriaObj: null,
        subCriteriaObj: [],
        status: ""
      },
      filter: {
        from: "",
        to: ""
      },
      columnNames: [
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Employee Name",
          key: "name"
        },
        {
          label: "Email Id",
          key: "email_id"
        },
        // {
        //   label: "Location",
        //   key: "location"
        // },
        {
          label: "Effective From",
          key: "effective_from"
        },
        {
          label: "Status",
          key: "current_status"
        },
        {
          label: "Actions",
          key: "action"
        }
      ],

      searchText: "",
      employeeData: [],
      revisesalaryList: [{}],
      applyToOptions: [],
      revisedByOptions: [],
      locationList: [],
      bandList: [],
      designationList: [],
      gradeList: [],
      payGroupData: [],
      showRevokeRevisePopup:false,
      showWarningMsg:false,
      tempRecord:null,
      failuremsg:false,
      stopSalaryEmployee: [],
      releaseSalaryEmployee: [],
      tempList:[],
      holdReleaseSalaryValue: false,
      role: ""
    };
  },
  activated() {
    this.setConstantsData();
    this.fetchPaygroups();
    this.getEmployees();
    this.getEmployeeStatus();
    this.getOrgLeIdList();
  },
  mounted(){
    this.getEmployeeStatus();
    this.getOrgLeIdList();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      heldemp: state => state.dashboard.payroll.utilities.holdsalary
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifTeamleaderAnchorPermission() {
        if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.holdReleaseSalaryValue) {
            return true;
          } else {
            return false;
          }
        } 
        // else {
        // return true 
        // }
    }
  },
  methods: {
    ...mapActions({
      hold: "dashboard/payroll/utilities/holdsalary/hold",
      getAll: "dashboard/payroll/utilities/holdsalary/fetchAll",
      fetch_paygroups: "onboard/paygroup/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_bunits: "onboard/business_units/fetchAll",
      fetch_costcentre: "onboard/cost_centres/fetchAll",
      fetch_loc: "onboard/locations/fetchAll",
      act_changeEditMode:
        "dashboard/payroll/utilities/holdsalary/changeEditMode",
      fetch_status_list:"dashboard/payroll/utilities/holdsalary/getStatusList",
      fetch_employee_status: "dashboard/payroll/utilities/holdsalary/getEmployeeByIDStatus",
    }),
    
     myDate(dates){
      let date= new Date(dates)
           let day= date.getDate().toString().padStart(2,"0")
           let month = (date.getMonth()+1).toString().padStart(2,"0")
           let year = date.getFullYear()
           let effective_from= day+"/"+month+"/"+year
           //console.log(effective_from)
           return effective_from         
    },

    // store res obj in local obj or array and seperate data as per employee status
      // store data in three seperate array
      // send that data to child or tab according status
    async getEmployeeStatus(){

      try{
          let res = await this.fetch_status_list(this.le_id)
           res.data.payload.data.hold.forEach(element => {
               this.employeeData.push({
                   code: element.code,
           employee_id: element.employee_id,
           name: element.name,
           email_id: element.email_id,
           legal_entity_id: element.legal_entity_id,
           current_status:element.current_status,
           id:element.id,
           createdBy:element.createdBy,
           updatedBy: element.updatedBy,
           customAttr: element.customAttr,
           previous_status: element.previous_status,
           effective_from: this.myDate(element.effective_from),
           reason: element.reason,
           it_projection: element.it_projection,
           created_at: element.created_at,
           updated_at: element.updated_at,
           deleted_at: element.deleted_at
          })
           }
          )
          this.tempList = res.data.payload.data.hold;
      }catch(err){
        //console.log(err);
      }
    },


    refresh() {
      this.page = 1;
      this.criteria = null;
      this.subCriteria = [];
      this.employeeData = [];
    },

    onScroll() {
      let bottomOfWindow =
        this.$refs.table_div.scrollHeight - this.$refs.table_div.scrollTop <=
        this.$refs.table_div.offsetHeight;
      if (bottomOfWindow && this.employeeData.length < this.totalEmployees) {
        this.page += 1;
        this.fetchEployees();
      }
    },


    dropdown(slots) {
      try {
        let idx = this.employeeData.findIndex(obj => {
          return obj.id == slots.id;
        });
        this.employeeData.forEach((data, index) => {
          if (index !== idx) {
            data.showDropDown = false;
          }
        });
        if (idx > -1) {
          this.employeeData[idx].showDropDown = this.employeeData[idx]
            .showDropDown
            ? false
            : true;
          this.employeeData = [...this.employeeData];
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    stopSalary(record) {
      //this.$emit("swichTab", 0, record);
      //this.$emit("reviseSalary", record);
      this.stopSalaryEmployee=record;
      this.showStopSalaryPopup = true;
    },

     releaseSalary(record) {
      //this.showRevokeRevisePopup= true;
      this.releaseSalaryEmployee=record;
      this.showreleaseSalaryPopup = true;
      // this.$emit("RevokeReviseSalary", record);
     //this.tempRecord=record;
     //this.showWarningMsg = true;

    },

    bulkuploadSalary() {
        this.showHoldStopReleasePopup = true;
    },

    popupHide() {
      this.showreleaseSalaryPopup = false;
      this.showStopSalaryPopup = false;
      this.showHoldStopReleasePopup = false;
    },

    cancel() {
      this.showWarningMsg = false;
    },

    backToSalaryDataPage() {
        this.showRevokeRevisePopup = false;
        this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });

    },

    /* function to search in local by name */
    filterDatas(val) {
      try {
        let tempArray = [];

        this.tempList.forEach(element => {
          if (element['name']) {
            if (element['name'].toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.employeeData = tempArray;
        } else {
          this.employeeData = this.tempList;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
        const org = this.orgId;
        const le = this.le_id;
        //console.log("Org:",org);
        //console.log("Le ID",le);
        let bodyParams = {};
        let  data = await this.getOrgLeList({
          data: {
            ...bodyParams
          }
        });
        this.role = data.data.user.userRole;
        this.holdReleaseSalaryValue = data.data.user.permissions.hold_release_salary ? true : false;
        //console.log("PL-3406",data);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "@/scss/_variables.scss";

a.anchor-underline-none {
  text-decoration: none;
}

.show-filter-block {
  position: absolute;
  transform: translate(-5%, -12%);
}

img.search-icon-filter {
  position: relative;
  right: 5px;
  top: 8px;
  width: 30px;
  height: 30px;
  //margin: 38px 6px 29px 32px;
  padding: 7px 4px 6px;
}

span.filter-text {
  font-weight: 600;
  color: #34c0be;
  font-size: 14px;
}


.uploadMethoRadio {
  display: flex;
}
.action-section {
  margin: 0px;
  text-align: center;
  img {
    width: auto;
  }
  .action-menu {
    top: 0px;
    right: 54px;
    left: -182px;
    li {
      padding: 0px;
      padding: 10px 25px;
      font-weight: 500;
      &:not(:last-child) {
        border-bottom: solid 1px #97979759;
      }
    }
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
